import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import './App.css';

import configureStore from './store/configureStore';
import App from './App';
import registerServiceWorker from './registerServiceWorker';

const store = configureStore();

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root'),
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js